<script lang="ts">
    import { getUrlParam } from '../../helpers/url';

    import { map } from 'jquery';

    import axios from 'axios';
    import { countryList, OREndpoint } from '../../helpers/consts';

    import language from '../../lang/language';
    import { form, field } from 'svelte-forms';
    import { onMount } from 'svelte';
    import {
        required,
        email,
        pattern,
        matchField,
    } from 'svelte-forms/validators';
    import { parse } from 'date-fns';
    import { formatDate, formatMoney } from '../../helpers/common';

    const firstName = field('firstName', '', [required()]);
    const lastName = field('lastName', '', [required()]);
    const userEmail = field('email', '', [required(), email()]);
    const conf_email = field('conf_email', '', [
        required(),
        email(),
        matchField(userEmail),
    ]);
    const phone = field('phone', '', [pattern(/\d+/), required()]);
    const mobile = field('mobile', '', [pattern(/\d+/), required()]);
    const address = field('address', '', [required()]);
    const city = field('city', '', [required()]);
    const state = field('state', '', [required()]);
    const zipcode = field('zipcode', '', [required()]);
    const country = field('country', '', [required()]);
    const marketing = field('marketing', '', []);
    const business = field('business', '', []);
    const specialRequest = field('specialRequest', '', []);

    const myForm = form(
        firstName,
        lastName,
        userEmail,
        conf_email,
        phone,
        mobile,
        address,
        city,
        state,
        zipcode,
        country,
        marketing,
        business,
        specialRequest
    );

    const formKey = {
        firstName: language.firstName,
        lastName: language.lastName,
        userEmail: language.userEmail,
        conf_email: language.conf_email,
        phone: language.phone,
        mobile: language.mobile,
        address: language.address,
        city: language.city,
        state: language.state,
        zipcode: language.zipcode,
        country: language.country,
        marketing: language.marketing,
        business: language.business,
        specialRequest: language.specialRequest,
    };

    const productId = getUrlParam('id');

    const onRequestReq = localStorage.getItem('onrequest')
        ? JSON.parse(localStorage.getItem('onrequest'))
        : {};

    console.log(productId, onRequestReq);

    const getTotalPrice = (req) => {
        const price = req.Price;
        let extrasPrice = 0;

        if (req.ProductExtras.length > 0) {
            req.ProductExtras.forEach((extra) => {
                extrasPrice += JSON.parse(extra).TotalCost;
            });
        }
        return price + extrasPrice;
    };

    async function onSubmit(e) {
        e.preventDefault();
        await myForm.validate();
        if ($myForm.errors.length == 0) {
            const request = {
                ProductDetails: JSON.stringify(onRequestReq),
                CustomerDetails: JSON.stringify(myForm.summary()),
                TotalPrice: getTotalPrice(onRequestReq),
                ReturnUrl: window.location.href,
            };

            console.log(request);
            await axios
                .post(
                    OREndpoint + '/checkout',
                    {
                        ...request,
                    },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: 'application/json',
                        },
                    }
                )
                .then(function (response) {
                    if (response.data) {
                        window.location.replace(response.data.url);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }
    onMount(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
</script>

<div class="box">
    <h2>{onRequestReq.SupplierName}</h2>

    <h4>{language.booking_information}</h4>
    <table class="table table-bordered">
        <thead>
            <tr>
                <th> {language.product} </th>
                <th> {language.options_costs} </th>
                <th> {language.totals} </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>{onRequestReq.ProductName}</td>
                <td>
                    <p>{onRequestReq.Adults} {language.adult}</p>
                    <p>
                        {language.check_in}: {formatDate(
                            onRequestReq.CommencementDate,
                            'EEEE, dd MMM yyyy'
                        )}
                    </p>
                    <p>
                        {language.check_out}: {formatDate(
                            onRequestReq.ConcludeDate,
                            'EEEE, dd MMM yyyy'
                        )}
                    </p>
                </td>
                <td>¥{formatMoney(onRequestReq.Price)}</td>
            </tr>
            {#if onRequestReq.ProductExtras.length > 0}
                {#each onRequestReq.ProductExtras as extra}
                    <tr>
                        <td />
                        <td>{JSON.parse(extra).Name}</td>
                        <td>¥{formatMoney(JSON.parse(extra).TotalCost)}</td>
                    </tr>
                {/each}
            {/if}
            <tr>
                <td colspan="2" style="text-align:right">{language.totals}</td>
                <td>¥{formatMoney(getTotalPrice(onRequestReq))}</td>
            </tr>
        </tbody>
    </table>
    <div class="col-sm-12 mb-3">
        <h4>{formKey.specialRequest}</h4>
        <div class="input-wrapper icon">
            <input
                bind:value={$specialRequest.value}
                class="input-field"
                type="text"
                placeholder={language.search_keyword}
            />
        </div>
    </div>
</div>

<div class="box">
    <h2 class="text-center">{language.customer_detail}</h2>
    <!-- svelte-ignore component-name-lowercase -->
    <form>
        <div class="row mx-auto w-sm-50">
            <div class="col-sm-6 mb-3">
                <h4>{formKey.firstName}</h4>
                <div class="input-wrapper icon">
                    <input
                        bind:value={$firstName.value}
                        class="input-field"
                        type="text"
                        placeholder={language.search_keyword}
                    />
                </div>

                {#if $myForm.hasError('firstName.required')}
                    <div class="red-text">
                        {formKey.firstName}
                        {language.is_required}
                    </div>
                {:else}
                    <div class="invisible">error</div>
                {/if}
            </div>
            <div class="col-sm-6 mb-3">
                <h4>{formKey.lastName}</h4>
                <div class="input-wrapper icon">
                    <input
                        bind:value={$lastName.value}
                        class="input-field"
                        type="text"
                        placeholder={language.search_keyword}
                    />
                </div>
                {#if $myForm.hasError('lastName.required')}
                    <div class="red-text">
                        {formKey.lastName}
                        {language.is_required}
                    </div>
                {:else}
                    <div class="invisible">error</div>
                {/if}
            </div>
            <div class="col-sm-12 mb-3">
                <h4>{formKey.userEmail}</h4>
                <div class="input-wrapper icon">
                    <input
                        bind:value={$userEmail.value}
                        class="input-field"
                        type="email"
                        placeholder={language.search_keyword}
                    />
                </div>
                {#if $myForm.hasError('email.required')}
                    <div class="red-text">
                        {formKey.userEmail}
                        {language.is_required}
                    </div>
                {:else if $myForm.hasError('email.not_an_email')}
                    <div class="red-text">
                        {formKey.userEmail}
                        {language.is_not_valid}
                    </div>
                {:else}
                    <div class="invisible">error</div>
                {/if}
            </div>
            <div class="col-sm-12 mb-3">
                <h4>{formKey.conf_email}</h4>
                <div class="input-wrapper icon">
                    <input
                        bind:value={$conf_email.value}
                        class="input-field"
                        type="email"
                        placeholder={language.search_keyword}
                    />
                </div>
                {#if $myForm.hasError('conf_email.required')}
                    <div class="red-text">
                        {formKey.conf_email}
                        {language.is_required}
                    </div>
                {:else if $myForm.hasError('conf_email.match_field')}
                    <div class="red-text">
                        {formKey.conf_email}
                        {language.is_not_the_same}
                    </div>
                {:else if $myForm.hasError('conf_email.not_an_email')}
                    <div class="red-text">
                        {formKey.conf_email}
                        {language.is_not_valid}
                    </div>
                {:else}
                    <div class="invisible">error</div>
                {/if}
            </div>
            <div class="col-sm-6 mb-3">
                <h4>{formKey.phone}</h4>
                <div class="input-wrapper icon">
                    <input
                        bind:value={$phone.value}
                        class="input-field"
                        type="text"
                        placeholder={language.search_keyword}
                    />
                </div>
                {#if $myForm.hasError('phone.required')}
                    <div class="red-text">
                        {formKey.phone}
                        {language.is_required}
                    </div>
                {:else if $myForm.hasError('phone.pattern')}
                    <div class="red-text">
                        {formKey.phone}
                        {language.must_be_a_number}
                    </div>
                {:else}
                    <div class="invisible">error</div>
                {/if}
            </div>
            <div class="col-sm-6 mb-3">
                <h4>{formKey.mobile}</h4>
                <div class="input-wrapper icon">
                    <input
                        bind:value={$mobile.value}
                        class="input-field"
                        type="text"
                        placeholder={language.search_keyword}
                    />
                </div>
                {#if $myForm.hasError('mobile.required')}
                    <div class="red-text">
                        {formKey.mobile}
                        {language.is_required}
                    </div>
                {:else if $myForm.hasError('mobile.pattern')}
                    <div class="red-text">
                        {formKey.phone}
                        {language.must_be_a_number}
                    </div>
                {:else}
                    <div class="invisible">error</div>
                {/if}
            </div>
            <div class="col-sm-12 mb-3">
                <h4>{formKey.address}</h4>
                <div class="input-wrapper icon">
                    <input
                        bind:value={$address.value}
                        class="input-field"
                        type="text"
                        placeholder={language.search_keyword}
                    />
                </div>
                {#if $myForm.hasError('address.required')}
                    <div class="red-text">
                        {formKey.address}
                        {language.is_required}
                    </div>
                {:else}
                    <div class="invisible">error</div>
                {/if}
            </div>
            <div class="col-sm-4 mb-3">
                <h4>{formKey.city}</h4>
                <div class="input-wrapper icon">
                    <input
                        bind:value={$city.value}
                        class="input-field"
                        type="text"
                        placeholder={language.search_keyword}
                    />
                </div>
                {#if $myForm.hasError('city.required')}
                    <div class="red-text">
                        {formKey.city}
                        {language.is_required}
                    </div>
                {:else}
                    <div class="invisible">error</div>
                {/if}
            </div>
            <div class="col-sm-4 mb-3">
                <h4>{formKey.state}</h4>
                <div class="input-wrapper icon">
                    <input
                        bind:value={$state.value}
                        class="input-field"
                        type="email"
                        placeholder={language.search_keyword}
                    />
                </div>
                {#if $myForm.hasError('state.required')}
                    <div class="red-text">
                        {formKey.state}
                        {language.is_required}
                    </div>
                {:else}
                    <div class="invisible">error</div>
                {/if}
            </div>
            <div class="col-sm-4 mb-3">
                <h4>{formKey.zipcode}</h4>
                <div class="input-wrapper icon">
                    <input
                        bind:value={$zipcode.value}
                        class="input-field"
                        type="email"
                        placeholder={language.search_keyword}
                    />
                </div>
                {#if $myForm.hasError('zipcode.required')}
                    <div class="red-text">
                        {formKey.zipcode}
                        {language.is_required}
                    </div>
                {:else}
                    <div class="invisible">error</div>
                {/if}
            </div>
            <div class="col-sm-12 mb-3">
                <h4>{formKey.country}</h4>
                <div class="input-wrapper icon">
                    <select
                        class="input-field"
                        type="text"
                        placeholder="Choose price"
                        bind:value={$country.value}
                    >
                        <option value="">{language.select_country}</option>
                        {#each countryList as country}
                            <option
                                value="{parseInt(
                                    country.number,
                                    10
                                )}_{country.name}">{country.name}</option
                            >
                        {/each}
                    </select>
                </div>
                {#if $myForm.hasError('country.required')}
                    <div class="red-text">
                        {formKey.country}
                        {language.is_required}
                    </div>
                {:else}
                    <div class="invisible">error</div>
                {/if}
            </div>

            <div class="col-sm-12">
                <button
                    class="first-button"
                    on:click={(e) => onSubmit(e)}
                    disabled={!$myForm.valid}>{language.submit}</button
                >
            </div>
        </div>
    </form>
</div>

<style>
    .first-button:disabled {
        opacity: 0.5;
    }

    .w-sm-50 {
        width: 50%;
    }
    @media screen and (max-width: 568px) {
        .w-sm-50 {
            width: 100%;
        }
    }
</style>
